module.exports = __webpack_public_path__ + "static/img/logo-gongcha.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-gongcha.jpg
// module id = LjW8
// module chunks = 88